import React from "react";
import Modal from 'react-modal';

import classNames from 'classnames/bind';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import style from './index.module.css';

const cx = classNames.bind(style);



interface ShareModelProps {
    isOpen: boolean;
    handleClose: () => void;
}

const BeginnerGuideModel: React.FC<ShareModelProps> = ({
    isOpen,
    handleClose,

}) => {
    const buttonStyle = {
        width: "30px",
        background: 'none',
        border: '0px',
        color: "white"
    };

    const properties = {
        prevArrow: <button style={{ ...buttonStyle }}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
        </svg></button>,
        nextArrow: <button style={{ ...buttonStyle }
        }>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
            </svg></button >
    }
    React.useEffect(() => {
        if (isOpen) {
            (window.parent as any).showBanner(0);
            const px = Math.round(window.innerHeight / (100 / 100));
            (window.parent as any).resizeIframe(px);
        }
        if (!isOpen) { (window.parent as any).showBanner(1); }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            contentLabel=""
            onRequestClose={handleClose}
            className="GuideModal"
            overlayClassName="GuideModalOverlay"
            shouldCloseOnOverlayClick={false}
            ariaHideApp={false}
        >
            <>
                <div>
                    <div className={cx("modalTitle")}>新手指引</div>
                    <div className={cx("modalRight")}>
                        <button className={cx("modalCloseButton")} onClick={handleClose} >
                            <span className={cx("modalCloseButtonFont")}>&times;</span>
                        </button>
                    </div>
                </div>
                <div>
                    <Slide {...properties} autoplay={false} slidesToShow={1} transitionDuration={300}>
                        <div className={cx("each-slide-effect")}>
                            <div className={cx("each-slide-wrap")}>
                                <img className={cx("desktop-hide")} src={require('../../static/image/Guide1-m.png')} />
                                <img className={cx("mobile-hide")} src={require('../../static/image/Guide1.png')} />
                            </div>
                        </div>
                        <div className={cx("each-slide-effect")}>
                            <div className={cx("each-slide-wrap")}>
                                <img className={cx("desktop-hide")} src={require('../../static/image/Guide2-m.png')} />
                                <img className={cx("mobile-hide")} src={require('../../static/image/Guide2.png')} />
                            </div>
                        </div>
                        <div className={cx("each-slide-effect")}>
                            <div className={cx("each-slide-wrap")}>
                                <img className={cx("desktop-hide")} src={require('../../static/image/Guide3-m.png')} />
                                <img className={cx("mobile-hide")} src={require('../../static/image/Guide3.png')} />
                            </div>
                        </div>
                        <div className={cx("each-slide-effect")}>
                            <div className={cx("each-slide-wrap")}>
                                <img className={cx("desktop-hide")} src={require('../../static/image/Guide4-m.png')} />
                                <img className={cx("mobile-hide")} src={require('../../static/image/Guide4.png')} />
                            </div>
                        </div>
                        <div className={cx("each-slide-effect")}>
                            <div className={cx("each-slide-wrap")}>
                                <img className={cx("desktop-hide")} src={require('../../static/image/Guide5-m.png')} />
                                <img className={cx("mobile-hide")} src={require('../../static/image/Guide5.png')} />
                            </div>
                        </div>

                    </Slide>
                </div>
                <div className={cx("guidemodalFoot")}>

                </div>
            </>
        </Modal >

    );
}

export default BeginnerGuideModel;